import Head from 'next/head'
import Layout from 'src/components/layout'
import LinkSeo from 'src/components/layout/linkSeo'
import MetaSeo from 'src/components/layout/metaSeo'
import AutoTrack from 'src/components/track_page/auto_track'
import Comment from 'src/components/track_page/comment'
import InstallGuide from 'src/components/track_page/install_guide'
import LogisticsInfo from 'src/components/track_page/logistics_info'
import ShopifyIntro from 'src/components/track_page/shopify_intro'
import useGA from 'src/hooks/use_ga'
import useI18n from 'src/hooks/use_i18n'
import { getV5Front } from 'src/utils/server_global'
import { DEFAULT_CARRIER_INFO_MARK } from '../constants/carrier_info_mark'
import { CarrierInfoMarkDTO } from '../types'

const logger = require('@/config/logger')

interface Props {
  carrierInfoMark: CarrierInfoMarkDTO
  country: string | any
}

export default function TrackPage({ carrierInfoMark, country }: Props) {
  const { $t, activeLocale: locale } = useI18n()

  useGA('customers')

  return (
    <>
      <MetaSeo
        title={$t('ResWwwPSeo.global.__seoTrackPageTitle')}
        description={$t('ResWwwPSeo.global.__seoTrackPageDesc')}
      />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `
            {
              "@context": "https://schema.org/",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "Homepage",
                "item": "https://www.17track.net/${locale}"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "Shopify APP",
                "item": "https://www.17track.net/${locale}/track_page"
              }]
            }
          `
          }}
        ></script>
      </Head>
      <LinkSeo TagType="track_page" routeLang={locale} />
      <Layout carrierInfoMark={carrierInfoMark} country={country}>
        <ShopifyIntro />
        <AutoTrack />
        <LogisticsInfo carrierInfoMark={carrierInfoMark} />
        <Comment />
        <InstallGuide />
      </Layout>
    </>
  )
}

export async function getServerSideProps({ req, locale }) {
  try {
    const V5Front = await getV5Front('www', locale)
    const { 'cf-ipcountry': country } = req.headers
    const carrierInfoMark = await fetch(`https://res.17track.net/asset/carrier/info/mark.${locale}.json`)
      .then((res) => res.json())
      .catch((error) => {
        logger.error('track_page页面获取carrierInfoMark信息异常', { message: error.message })
        return DEFAULT_CARRIER_INFO_MARK // 兜底数据
      })

    return {
      props: { locale, V5Front, carrierInfoMark, country: country ?? 'CN' }
    }
  } catch (error: any) {
    logger.error('track_page页面请求异常', { message: error.message })
  }
}
